import React, { forwardRef } from 'react';

const AboutUs = forwardRef((props, ref) => {
  const lang = props.lang;

  const content = {
    hero: {
      el: {
        header: 'Το πρωτο ιδιωτικό κεπ για κατοίκους εξωτερικού στην Ελλάδα!',
        subheader: 'Εξυπηρετούμε ολόκληρο το κόσμο.'
      },
      en: {
        header: 'The first private Citizen Service Center (KEP) for residents abroad in Greece!',
        subheader: 'We serve the whole world.'
      }
    },
    whyUs: {
      el: {
        header: 'Γιατί εμάς',
        reasons: [
          {
            text:"Ολιστική προσέγγιση σε όλα τα φορολογικά και διεκπεραιωτικά ζητήματα.",
            icon:"🌐",
            header:"Ολιστική Προσέγγιση"
          },
          {
            text:"Ολοκληρωμένες υπηρεσίες σε θέματα νομικά-φοροτεχνικά-τεχνικά-συμβουλευτικά.",
            icon:"🏛️",
            header:"Ολοκληρωμένες Υπηρεσίες"
          },
          {
            text:"Ανταγωνιστικά πακέτα τιμών.",
            icon:"💰",
            header:"Ανταγωνιστικές Τιμές"
          },
          {
            text:"Διαφάνεια στις διεκπεραιώσεις υπέρ τρίτων και αναζήτηση οικονομικών προσφορών σε μεταφραστικά γραφεία μέσω του δικτύου συνεργατών.",
            icon:"🤝",
            header:"Διαφάνεια & Συνεργασίες"
          },
          {
            text:"Φιλική και απλοποιημένη προσέγγιση σε περίπλοκα φορολογικά ζητήματα.",
            icon:"😊",
            header:"Φιλική Προσέγγιση"
          },
        ]
      },
      en: {
        header: 'Why us',
        reasons: [
          {
            text:"Holistic approach to all tax and procedural issues.",
            icon:"🌐",
            header:"Holistic Approach"
          },
          {
            text:"Complete services on legal, tax, technical, and consulting matters.",
            icon:"🏛️",
            header:"Comprehensive Services"
          },
          {
            text:"Competitive pricing packages.",
            icon:"💰",
            header:"Competitive Prices"
          },
          {
            text:"Transparency in third-party procedures and finding economic offers in translation services through the partner network.",
            icon:"🤝",
            header:"Transparency & Partnerships"
          },
          {
            text:"Friendly and simplified approach to complex tax issues.",
            icon:"😊",
            header:"Friendly Approach"
          },
        ]
      }
    },
    scheduleAMeting: {
      el: {
        header:
          'Άμεση εξυπηρέτηση και προγραμματισμός ραντεβού online μέσω Skype, Viber, Google meet, Zoom, Whats up σε όλες τις ζώνες ώρας.  Κλείσε το ραντεβού σου τωρα'
      },
      en: {
        header: ''
      }
    },
    info_2: {
      el: {
        info1: {
          icon: "📈",
          header:"Εξυπηρέτηση Κατοίκων Εξωτερικού",
          text:"Εξ αποστάσεως εξυπηρέτηση κατοίκων εξωτερικού , φορολογική συμβουλευτική και επενδυτικός σχεδιασμός επαναπατρισμού , ένταξη στα φορολογικά κίνητρα ποσέλκυσης κατοικων εξωτερικού 5Α, 5Β, 5Γ ΤΟΥ Ν. 4172/2013 (ΚΦΕ)"
        },
        info2:{
          icon: "🛡️",
          header:"Εξατομικευμένες Λύσεις",
          text:"Παρέχουμε εξατομικευμένες λύσεις και διασφαλίζουμε τη συμμόρφωση με τους κανονισμούς της φορολογικής νομοθεσίας με ακεραιότητα, επαγγελματισμό και απόλυτη εχεμύθεια"
        }
      },
      en: {
        info1: {
          icon: "📈",
          header:"Services for Residents Abroad",
          text:"Remote service for residents abroad, tax consulting, and investment planning for repatriation. Assistance with inclusion in the tax incentives for attracting foreign residents (5A, 5B, 5C) of Law 4172/2013 (Tax Code)."
        },
        info2:{
          icon: "🛡️",
          header:"Personalized Solutions",
          text:"We provide personalized solutions and ensure compliance with tax regulations with integrity, professionalism, and complete confidentiality."
        }
      }
    },
    people: {
      el: {
        header:
          'Η ομάδα μας αποτελείτε από ανεξάρτητα εξατομικευμένα μέλη που παρέχουν φορολογική καθοδήγηση.',
        footer:
          'Η ομάδα μας ενισχυόμενη από άλλους ειδικούς όταν απαιτείται για κάθε περίπτωση ,παρέχει μια πληθώρα υπηρεσιών όπως νομική στήριξη , μεταφράσεις κ.α.  ',
        people: [
          {
            img: './images/amalia.png',
            name: 'Αθανασιάδου Αμαλία',
            info: ' είναι απόφοιτος του τμήματος Διοίκησης Επιχειρήσεων του Ελληνικού Ανοιχτού Πανεπιστήμιου και απόφοιτος του τμήματος Λογιστικής και Χρηματοοικονομικών Επιστημών του ΑΤΕΙ Σερρών. Κατέχει μεταπτυχιακό τίτλο εξειδίκευσης στην Λογιστική και στα Πληροφοριακά Συστήματα από το Πανεπιστημίου του Greenwich. Κατέχει άδεια ασκήσεως επαγγέλματος Οικονομολόγου και είναι μέλος του Οικονομικού Επιμελητηρίου. Έχει εργαστεί στο παρελθόν σε λογιστικά γραφεία αλλά και επιχειρήσεις διαφόρων κλάδων. Από το 2016 ασχολείται ενεργά με την διεκπεραίωση αιτήσεων μεταφοράς φορολογικής κατοικίας καθώς και  με παροχή εξατομικευμένων υπηρεσιών τόσο σε επιχειρήσεις όσο και σε φυσικά πρόσωπα. Επιπρόσθετα έχει συνεργαστεί με δημόσια ιδρύματα και διαθέτει γνώσεις Δημόσιου Λογιστικού Συστήματος.'
          },
          {
            img: './images/dora.png',
            name: 'Ντουλμούζη Θεοδώρα',
            info: ' είναι επαγγελματίας με πολυετή εμπειρία στον τομέα της λογιστικής, των ανθρώπινων πόρων και της διοίκησης επιχειρήσεων. Στη διάρκεια της καριέρας της, έχει αποκτήσει εξειδίκευση στον τομέα της μεταβολής φορολογικής κατοικίας και της φορολογίας κατοίκων εξωτερικού, προσφέροντας αξιόπιστες και εξειδικευμένες λύσεις σε επιχειρήσεις και ιδιώτες.Η επαγγελματική πορεία της περιλαμβάνει την εργασία ως βοηθός καθηγητή στο ΤΕΙ Σερρών με ειδικότητα στους Ανθρώπινους Πόρους, τη γραμματειακή υποστήριξη σε εμπορικές και κατασκευαστικές εταιρίες, καθώς και τον ρόλο του βοηθού λογιστή για περισσότερα από έξι χρόνια. Επιπλέον, έχει ιδρύσει και διαχειρίζεται την Digital Accounting, ένα λογιστικό γραφείο που εξειδικεύεται σε οικονομικές και φορολογικές υπηρεσίες.Κατέχει άδεια Α τάξης λογιστή, πτυχίο στη Διοίκηση Επιχειρήσεων από το ΤΕΙ Σερρών και πιστοποίηση Financial Accounting από το Πανεπιστήμιο Αθηνών (Καποδιστριακό). Η εμπειρία της σε πολυάριθμα projects με επίκεντρο τη φορολογία και τη λογιστική της επιτρέπει να προσφέρει ολοκληρωμένες και εξατομικευμένες λύσεις στους πελάτες της.'
          }
        ]
      },
      
      en: {
        header:
        'Our team consists of independent, personalized members who provide tax guidance.',
      footer:
        'Our team, supported by other specialists when required for each case, offers a wide range of services such as legal support, translations, and more.',
      people: [
        {
          img: './images/amalia.png',
          name: 'Amalia Athanasiadou',
          info: 'is a graduate of the Business Administration department at the Hellenic Open University and the Accounting and Financial Sciences department at ATEI Serres. She holds a Master’s degree specializing in Accounting and Information Systems from the University of Greenwich. She is a licensed Economist and a member of the Economic Chamber. She has previously worked in accounting firms as well as in businesses across various industries. Since 2016, she has been actively involved in handling tax residency transfer applications and providing personalized services to both businesses and individuals. Additionally, she has collaborated with public institutions and possesses knowledge of the Public Accounting System.'
        },
        {
          img: './images/dora.png',
          name: 'Theodora Doulmouzi',
          info: 'is a professional with extensive experience in accounting, human resources, and business administration. Throughout her career, she has specialized in tax residency changes and taxation for foreign residents, offering reliable and tailored solutions to businesses and individuals. Her professional journey includes working as a teaching assistant at TEI Serres with a specialization in Human Resources, secretarial support in commercial and construction companies, and serving as an assistant accountant for over six years. Furthermore, she founded and manages Digital Accounting, an accounting firm specializing in financial and tax services. She holds a Class A accountant’s license, a degree in Business Administration from TEI Serres, and a Financial Accounting certification from the National and Kapodistrian University of Athens. Her experience in numerous tax and accounting projects enables her to provide comprehensive and customized solutions for her clients.'
        }
      ]
      }
    },

    infoCards: {
      el:[
        {
          title: "Εξυπηρέτηση Κατοίκων Εξωτερικού",
          icon: '🌍',
          text: "📌 Εξ αποστάσεως εξυπηρέτηση κατοίκων εξωτερικού για φορολογική συμβουλευτική, επενδυτικό σχεδιασμό επαναπατρισμού και ένταξη στα φορολογικά κίνητρα προσέλκυσης κατοίκων εξωτερικού (5Α, 5Β, 5Γ - Ν. 4172/2013)."
        },
        {
          title: "Εξατομικευμένες Λύσεις",
          icon: '⚖️',
          text: "📌 Παρέχουμε εξατομικευμένες λύσεις και διασφαλίζουμε τη συμμόρφωση με τη φορολογική νομοθεσία με ακεραιότητα, επαγγελματισμό και απόλυτη εχεμύθεια."
        },
        {
          title: "Ολιστική Υποστήριξη για Αλλοδαπούς Επενδυτές στην Ελλάδα",
          icon: '🏢',
          text: "📌 Υποστηρίζουμε κατοίκους εξωτερικού που θέλουν να επενδύσουν στην Ελλάδα σε ακίνητα ή επιχειρήσεις. Από την αρχική έρευνα μέχρι την ολοκλήρωση της επένδυσης, προσφέρουμε λύσεις με διαφάνεια, νομιμότητα και αποτελεσματικότητα."
        },
        {
          title: "Ολοκληρωμένες Υπηρεσίες για Επενδυτές του Εξωτερικού",
          icon: '📜',
          text: "📌 Φορολογική & Νομική Συμβουλευτική: Καθοδήγηση στο φορολογικό και νομικό πλαίσιο της Ελλάδας για συμμόρφωση και σωστή επενδυτική στρατηγική. 📌 Διεκπεραίωση Υποθέσεων: Ανάληψη όλων των γραφειοκρατικών διαδικασιών για την απόκτηση ακινήτων ή τη σύσταση επιχείρησης χωρίς φυσική παρουσία. 📌 Αντιπροσώπευση σε Δημόσιες Υπηρεσίες: Διαχείριση αιτήσεων, παρακολούθηση υποθέσεων και έγκαιρη ολοκλήρωση διαδικασιών στις αρμόδιες αρχές."
        },
        {
          title: "Διαφάνεια & Αξιοπιστία στις Διεκπεραιώσεις",
          icon: '🔍',
          text: "📌 Οι υπηρεσίες μας βασίζονται στη διαφάνεια και την πλήρη ενημέρωση των πελατών, διασφαλίζοντας την ομαλή διεκπεραίωση κάθε διαδικασίας."
        },
        {
          title: "Υποστήριξη σε Μεταφράσεις Εγγράφων",
          icon: '🏛️',
          text: "📌 Βοηθάμε στην αναζήτηση αξιόπιστων και οικονομικών μεταφραστικών υπηρεσιών για νομικά, φορολογικά και εμπορικά έγγραφα."
        },
      ],
      en:[
        {
          title: "Remote Services for Non-Residents",
          icon:'🌍',
          text:'📌 Remote tax consulting, repatriation investment planning, and eligibility for foreign resident tax incentives (5A, 5B, 5C - Law 4172/2013)'
        },
        {
          title: "Tailored Tax Solutions",
          icon: '⚖️',
          text: "📌 We provide tailored solutions ensuring compliance with tax laws while maintaining integrity, professionalism, and confidentiality."
        },
        {
          title: "Comprehensive Support for Foreign Investors in Greece",
          icon: '🏢',
          text: "📌 We support non-residents investing in Greece (real estate or business) by offering complete solutions from research to finalization with transparency and legal compliance."
        },
        {
          title: "Full-Service Solutions for Foreign Investors",
          icon: '📜',
          text: "📌 Tax & Legal Consulting: Guidance on Greece’s tax & legal framework to ensure compliance and smart investment strategies. 📌 Case Handling: We manage all bureaucracy for property acquisition or business setup remotely. 📌 Government Representation: We handle applications, monitor cases, and ensure timely completion of processes."
        },
        {
          title: "Transparency & Trust in Procedures",
          icon: '🔍',
          text: "📌 We ensure transparency and full client communication, guaranteeing a smooth handling of every process."
        },
        {
          title: "Translation Assistance for Official Documents",
          icon: '🏛️',
          text: "📌 We assist in finding reliable and cost-effective translation services for legal, tax, and commercial documents."
        },
      ],
    }
  };

  return (
    <>
      <section style={{paddingBlock:'10vh'}} className="add section-0 flex-column justify-content-between" ref={ref}>
        <div className="section-content hero">
          <img src="/images/logo.png" alt="logo" className="logo-hero mb-4" />
          <h2 className="text-center mb-4 font-large">{content.hero[lang].header}</h2>
          {/* <button style={{zIndex: 1000}} onClick={()=> window.scrollTo("#why-us")}> down</button> */}
        </div>
        <div className='hero-footer'>
          <h3>{content.hero[lang].subheader}</h3>
          <p className='m-0'>📧 info@ikeke.gr</p>
          <p className='m-0'>📞 +30 697 5644026</p>
          <p className='m-0'>📞 +30 698 0844128</p>
        </div>
      </section>
      <section className="info_2 section-3 justify-content-center pt-5">
        <div className="gap-5 section-content d-flex flex-wrap justify-content-center">
          {content.infoCards[lang].map(p=>(
            <div key={p.title} className="icon-card">
              <div className='d-flex align-items-center'>
              <i style={{marginRight:"5px", marginBottom:"10px", fontSize:"2rem"}} className="icon">{p.icon}</i>
              <h3 style={{ fontSize:"17px"}}>{p.title}</h3>
              </div>
              {p.text.split('📌').filter(Boolean).map(t=>(
                <p key={t}style={{ fontSize:"14px"}}>📌 {t}</p>
              ))}
            </div>
          ))}
          {/* <div className="icon-card">
            <i className="icon">{content.info_2[lang].info1.icon}</i>
            <h3>{content.info_2[lang].info1.header}</h3>
            <p className="">{content.info_2[lang].info1.text}</p>
          </div>
          <div className="icon-card">
            <i className="icon">{content.info_2[lang].info2.icon}</i>
            <h3>{content.info_2[lang].info2.header}</h3>
            <p className="">{content.info_2[lang].info2.text}</p>
          </div> */}
        </div>
      </section>
      <section style={{marginBlock:"15vh"}} id='why-us' className="why-us section-1">
        <div className="pe-5 p3-2 section-content">
          <h2 className='mb-5 text-center'>{content.whyUs[lang].header}</h2>
          <div className='d-flex flex-wrap gap-4'>
            {content.whyUs[lang].reasons.map((r, index) => (
              <div className='icon-box d-flex col-5' key={`whyUs-${index}`}>
                <div className="icon flex-shrink-0">
                <i>{r.icon}</i>
                </div>
                <div>
                  <h4 className='title'>{r.header}</h4>
                <p className='description'>{r.text}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    
      {/* <section className="schedule-a-meeting section-2">
        <div className='section-content'>
          <h2>{content.scheduleAMeting[lang].header} </h2>
          <img src="/images/example.png" alt="logo" className="logo-hero" />
          .πάτα εδώ (και θα το βαζει σε ένα σαιτ για να ζητησεις γοογλε ραντεβου 
        </div>
      </section>*/}
   
      <section className="people section-4">
        <div className="section-content w-100">
          <h3
            className="mb-5 text-center"
          >
            {content.people[lang].header}
          </h3>
          <div className="d-flex gap-5 justify-content-center flex-wrap mb-3 ">
            {content.people[lang].people.map((p, index) => (
              <div style={{fontSize:"14px"}} key={`people-${index}`} className="card people-card d-block w-25 p-4">
                <img src={p.img} className='round-image' />
                {lang === 'el' ? 'H' : ''} <b>{p.name}</b>
                {p.info}
              </div>
            ))}
          </div>
          <h5 className="text-center sub-title">{content.people[lang].footer}</h5>
        </div>
      </section>
      {/* <a href="#top" className="scroll-to-top">
        <svg
          width="16px"
          height="16px"
          viewBox="0 0 16 16"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="16" height="16" id="icon-bound" fill="none" />
          <polygon points="1.414,12.414 8,5.828 14.586,12.414 16,11 8,3 0,11" />
        </svg>
      </a> */}
    </>
  );
});

export default AboutUs;
